import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconNoPhotographyOutline = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-label="IconNoPhotographyOutline"
    fill="currentColor"
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M1.75.796A.99.99 0 0 0 1.029.5a1 1 0 0 0-.723.296.97.97 0 0 0-.3.71.95.95 0 0 0 .3.71l1.866 1.833a2.2 2.2 0 0 0-.585.412 1.9 1.9 0 0 0-.612 1.387v14.025a1.88 1.88 0 0 0 .613 1.397 1.95 1.95 0 0 0 1.408.591h17.273l1.356 1.337a1 1 0 0 0 .72.302 1.01 1.01 0 0 0 .721-.302.96.96 0 0 0 .3-.697.94.94 0 0 0-.3-.69zm1.246 19.077V5.875h1.037l4.5 4.42a4.3 4.3 0 0 0-.6 1.201c-.14.451-.21.92-.208 1.391-.013.62.101 1.236.336 1.811a4.6 4.6 0 0 0 1.03 1.536c.444.438.974.784 1.558 1.015a4.7 4.7 0 0 0 1.837.331 4.8 4.8 0 0 0 1.411-.205 4.4 4.4 0 0 0 1.219-.591l3.128 3.083zM23.388 4.474a1.92 1.92 0 0 0-1.4-.618h-3.99l-1.522-1.8a2 2 0 0 0-.71-.532 2.1 2.1 0 0 0-.84-.177h-4.844c-.3-.003-.596.058-.87.177a1.74 1.74 0 0 0-.68.532L7.12 3.748l2.159 2.1h12.706V18.4l2.02 1.937V5.848a1.9 1.9 0 0 0-.617-1.374M15.88 9.572c.552.512.95 1.163 1.149 1.883.169.71.215 1.444.138 2.17l-5.426-5.349a6.6 6.6 0 0 1 2.215.15c.735.203 1.4.6 1.924 1.146"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconNoPhotographyOutline);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
